module.exports = __webpack_public_path__ + "img/44-config-legislacoes-lista.d6c71462.png";